import type { ReactNode } from "react";

interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function SectionTitle({
  eyebrow,
  title,
  description,
  action,
}: SectionTitleProps) {
  return (
    <div className="mb-7 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="min-w-0">
        {eyebrow && (
          <p className="font-label mb-2 flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-accent-700">
            <span className="h-[2px] w-5 rounded-full bg-accent-500"></span>
            {eyebrow}
          </p>
        )}
        <h2 className="text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-500">
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}